<div class="separator"></div>
<app-home-faq-reduced [page]="'contacts'"></app-home-faq-reduced>